jQuery(function($) {
  $(window).on('scroll', function() {
    var scrollTop = $(window).scrollTop();
    var triggerPoint = $(window).height(); // ＝ 100vh

    if (scrollTop > triggerPoint) {
      $('#fix-header').fadeIn();
    } else {
      $('#fix-header').fadeOut();
    }
  });
});